import { render, staticRenderFns } from "./SignupPageSignUp.vue?vue&type=template&id=11b871d0"
import script from "./SignupPageSignUp.vue?vue&type=script&lang=js"
export * from "./SignupPageSignUp.vue?vue&type=script&lang=js"
import style0 from "./SignupPageSignUp.vue?vue&type=style&index=0&id=11b871d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports